import { render, staticRenderFns } from "./WithdrawalAuditForm.vue?vue&type=template&id=b4a588a2&scoped=true"
import script from "./WithdrawalAuditForm.vue?vue&type=script&lang=js"
export * from "./WithdrawalAuditForm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalAuditForm.vue?vue&type=style&index=0&id=b4a588a2&prod&lang=css"
import style1 from "./WithdrawalAuditForm.vue?vue&type=style&index=1&id=b4a588a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a588a2",
  null
  
)

export default component.exports